export default [
    { name: "Rio Branco", coordinates: [-67.8662019, -9.9862442] },
    { name: "Maceió", coordinates: [-35.7568902, -9.5943984] },
    { name: "Macapá", coordinates: [0.1019439, -51.1670724] },
    { name: "Manaus", coordinates: [-60.1075319, -3.0443101] },
    { name: "Salvador", coordinates: [-38.490317, -12.9015883] },
    { name: "Fortaleza", coordinates: [-38.5891584, -3.7899266] },
    { name: "Brasília", coordinates: [-48.0779611, -15.7744219] },
    { name: "Vitória", coordinates: [-49.4446947, -16.6954997] },
    { name: "Goiânia", coordinates: [-48.0779611, -15.7744219] },
    { name: "São Luís", coordinates: [-44.4383634, -2.6271281] },
    { name: "Cuiabá", coordinates: [-48.0779611, -15.7744219] },
    { name: "Campo Grande", coordinates: [-54.7057456, -20.4809249] },
    { name: "Belo Horizonte", coordinates: [-44.0342617, -19.9025411] },
    { name: "Belém", coordinates: [-48.5205932, -1.3411793] },
    { name: "João Pessoa", coordinates: [-34.9518092, -7.1464332] },
    { name: "Recife", coordinates: [-49.4302249, -25.4947398] },
    { name: "Teresina", coordinates: [-42.8112899, -5.0935648] },
    { name: "Rio de Janeiro", coordinates: [-43.7268521, -22.9132513] },
    { name: "Natal", coordinates: [-35.2924559, -5.7997438] },
    { name: "Porto Alegre", coordinates: [-51.3175682, -30.1084984] },
    { name: "Porto Velho", coordinates: [-63.8900121, -8.7564592] },
    { name: "Boa Vista", coordinates: [-36.2463902, -7.2660776] },
    { name: "Florianópolis", coordinates: [-48.7511475, -27.5707043] },
    { name: "São Paulo", coordinates: [-46.8761689, -23.6815303] },
    { name: "Aracaju", coordinates: [-37.1733679, -11.0058313] },
    { name: "Palmas", coordinates: [-48.417446, -10.2598832] },
  ];